import { Api } from "../axios-config/AxiosConfig";

export interface IParamsGetToken {
  skip?: string;
  take?: string;
  campoDePesquisa?: string;
  idEstabelecimento?: string | number;
  geracaoIniciaEm?: string;
  geracaoTerminaEm?: string;
  validadeIniciaEm?: string;
  validadeTerminaEm?: string;
  usoIniciaEm?: string;
  usoTerminaEm?: string;
}

export interface IToken {
  id?: number;
  token: string;
  origem: string;
  nomeCompletoUsuario: string;
  contaEmailUsuario: string;
  cpfCnpjRneUsuario: string;
  ipUsuario: string;
  nomeEstabelecimento: string;
  dataGeracao: string;
  dataValidade: string;
  dataUso: string | null;
}

export interface IResponseToken {
  data: IToken[];
  qtdTotalDeRegistros: number;
}

export interface IResponseTokenLog {
  idUsuario: string | null;
  dataGeracao: string;
  mensagem: string;
}

const getTokens = async (payload: IParamsGetToken): Promise<IResponseToken> => {
  try {
    const { data } = await Api().get<IResponseToken>(
      `/Token?Skip=${payload.skip ? payload.skip : 1}&Take=${
        payload.take ? payload.take : 1000
      }&CampoDePesquisa=${
        payload.campoDePesquisa ? payload.campoDePesquisa : ""
      }&IdEstabelecimento=${
        payload.idEstabelecimento ? payload.idEstabelecimento : ""
      }&GeracaoIniciaEm=${
        payload.geracaoIniciaEm ? payload.geracaoIniciaEm : ""
      }&GeracaoTerminaEm=${
        payload.geracaoTerminaEm ? payload.geracaoTerminaEm : ""
      }&ValidadeIniciaEm=${
        payload.validadeIniciaEm ? payload.validadeIniciaEm : ""
      }&ValidadeTerminaEm=${
        payload.validadeTerminaEm ? payload.validadeTerminaEm : ""
      }&UsoIniciaEm=${
        payload.usoIniciaEm ? payload.usoIniciaEm : ""
      }&UsoTerminaEm=${payload.usoTerminaEm ? payload.usoTerminaEm : ""}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

const getTokenLog = async (token: string): Promise<IResponseTokenLog[]> => {
  try {
    const { data } = await Api().get<IResponseTokenLog[]>(
      `/TokenLogValidacao/${token}`
    );

    console.log("*** data", data);
    return data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const AuditoriaService = { getTokens, getTokenLog };
